// INFO: Do not change the order of the enum values
export enum BridgeTemplateVersion {
  V6_12_0 = '6.12.0',
  V6_13_0 = '6.13.0',
  V6_13_2 = '6.13.2',
  V7_0_0 = '7.0.0',
  V7_1_0 = '7.1.0',
  V7_1_2 = '7.1.2',
  V7_1_3 = '7.1.3',
  V7_1_4 = '7.1.4',
  V7_2_0 = '7.2.0',
  V7_2_2 = '7.2.2',
  V7_2_3 = '7.2.3',
  V7_2_4 = '7.2.4',
  V7_2_5 = '7.2.5',
  V8_0_0 = '8.0.0',
  V8_0_1 = '8.0.1',
  V8_1_0 = '8.1.0',
  V8_1_1 = '8.1.1',
  V8_2_0 = '8.2.0',
  V8_2_1 = '8.2.1',
  V8_2_2 = '8.2.2',
  V8_3_0 = '8.3.0',
  V8_4_0 = '8.4.0',
  V8_4_1 = '8.4.1',
  V8_4_2 = '8.4.2',
  V8_5_0 = '8.5.0',
  V8_5_1 = '8.5.1',
  V8_5_2 = '8.5.2',
  V9_0_0 = '9.0.0',
  V10_0_0 = '10.0.0',
  V10_1_0 = '10.1.0',
}
